import { render, staticRenderFns } from "./RestSlides.vue?vue&type=template&id=aa30a84c&scoped=true&"
import script from "./RestSlides.vue?vue&type=script&lang=js&"
export * from "./RestSlides.vue?vue&type=script&lang=js&"
import style0 from "./RestSlides.vue?vue&type=style&index=0&id=aa30a84c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa30a84c",
  null
  
)

export default component.exports